import { render, staticRenderFns } from "./PowerBowl.vue?vue&type=template&id=0a4d8b96&"
import script from "./PowerBowl.vue?vue&type=script&lang=ts&"
export * from "./PowerBowl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports